import { Config } from "../../config";

class CacheServiceImpl {
  static instance = null;

  static getInstance() {
    if (!CacheServiceImpl.instance) {
      CacheServiceImpl.instance = new CacheServiceImpl();
    }
    return CacheServiceImpl.instance;
  }

  cacheStore = null;

  constructor() {
    this.cacheStore = localStorage;
  }

  getStorage() {
    return this.cacheStore;
  }

  get(module, key) {
    return this.getValueFromStorage(this.getStorage(), module, key);
  }

  put(module, key, value) {
    this.putValueIntoStorage(this.getStorage(), module, key, value);
  }

  getFromSession(module, key) {
    return this.getValueFromStorage(sessionStorage, module, key);
  }

  putIntoSession(module, key, value) {
    this.putForSession(module, key, value);
  }

  putForSession(module, key, value) {
    this.putValueIntoStorage(sessionStorage, module, key, value);
  }

  getValueFromStorage(storage, module, key) {
    if (!Config.CACHE_ENABLED && module !== "security") {
      return null;
    }
    var value = null;
    if (storage.getItem) {
      value = storage.getItem(this.rationalizeKey(module, key));
    } else {
      value = storage.get(this.rationalizeKey(module, key));
    }
    if (value == null) {
      return value;
    }
    value = JSON.parse(value);
    return value.value;
  }

  putValueIntoStorage(storage, module, key, value) {
    value = JSON.stringify({ value: value });
    if (storage.setItem) {
      storage.setItem(this.rationalizeKey(module, key), value);
      return;
    }
    storage.set(this.rationalizeKey(module, key), value);
  }

  rationalizeKey(module, key) {
    module = module == null ? "__default_module" : module + "";
    return module + "_" + key;
  }

  clear() {
    this.getStorage().clear();
    sessionStorage.clear();
  }
}

export const CacheService = CacheServiceImpl.getInstance();
